module.exports = __webpack_public_path__ + "static/media/four.d6c0f379.png";